import { z } from 'zod';

export const CustomVizIds = [
  'payBenchmarking',
  'payCorrection',
  'promotionCopilot',
  'binScatterMultiSelect',
  'binScatterCrossSelect',
  'hiringCopilot',
  'pipelineAnalysis',
  'biasAnalysis',
  'successPhenotypeV2',
  'topLevelAnalysis',
  'progress',
  'heatmap',
  'nlpGraph',
  'tableView',
  'timeSeriesTrends',
  'summaryStats',
  'richText',
  'geolocation',
  'externalStreamlit',
] as const;

export const CustomVizId = z.enum(CustomVizIds);

export type CustomVizId = z.infer<typeof CustomVizId>;
